import { apiReturnCallBack } from './ApiConfig';
import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import apiContainer from './apiContainer';
const api = new APICore();

const Expenses = apiContainer.Expenses
//GET--->
// Corrected getExpenses function
export async function getExpensesApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Expenses}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

//CREATE---->
export async function createExpenses(request) {
    try {
        return api.create(`${Expenses}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateExpenses(request, ExpensesId) {
    try {
        return api.update(`${Expenses}/${ExpensesId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteExpenses(ExpensesId) {
    try {
        return api.delete(`${Expenses}/${ExpensesId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

